import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import config from 'App/lib/config';

if (process.env.MIX_SENTRY_LARAVEL_DSN) {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: Number(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE),
    environment: config('app.env') as string,
    ignoreErrors: [/^ResizeObserver loop/],
  });
}
